import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ViewerScreen from './components/ViewerScreen';
import { ErrorBoundary } from './components/ErrorBoundary';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const isViewerRoute = window.location.pathname.startsWith('/viewer');

// Wissel het PWA-manifest uit zodat de viewer als aparte app op het beginscherm gezet kan worden
// met start_url=/viewer (opent altijd het scorebord, niet de hoofdapp)
if (isViewerRoute) {
  const manifestLink = document.querySelector('link[rel="manifest"]') as HTMLLinkElement | null;
  if (manifestLink) {
    manifestLink.href = '/manifest-viewer.json';
  }
}

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      {isViewerRoute ? <ViewerScreen /> : <App />}
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Notify the app that an update is available
    window.dispatchEvent(new CustomEvent('sw-update-available', { detail: registration }));
  }
});